import coreSearch from 'assets/core/js/entry/search'
import dataLayer from 'assets/core/js/page/search/dataLayer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import searchForm from 'assets/themes/vacances-campings/js/module/searchForm'
import budgetSlider from 'assets/themes/vacances-campings/js/page/search/budgetSlider'
import filters from 'assets/themes/vacances-campings/js/page/search/filters'
import imagesSliders from 'assets/themes/vacances-campings/js/page/search/imagesSliders'
import loading from 'assets/themes/vacances-campings/js/page/search/loading'
import map from 'assets/themes/vacances-campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/vacances-campings/js/page/search/openProductPageLinks'
import sorting from 'assets/themes/vacances-campings/js/page/search/sorting'

document.addEventListener('DOMContentLoaded', function () {
  dataLayer()
  imagesSliders.init()
  budgetSlider()
  openProductPageLinks()
  sorting()
  loading()
  filters()
  map()
  productFavorite()

  searchForm()
  coreSearch()
})
